<template>
  <input-wrapper
    @click="dofocus"
    :error="error"
    :helperText="helperText"
    :count="count"
    :limit="limit"
    :class="Object.assign({'text-box': 1}, classList)">

    <textarea
      ref="textarea"
      @focus="focus"
      @blur="blur"
      :rows="rows"
      v-model="currentValue"
      :id="id"
      :disabled="disabled"
      :maxlength="limit">
      {{value}}
    </textarea>
    
    <input-label :required="required" :for-id="id">{{placeholder}}</input-label>
  </input-wrapper>
</template>

<script>
  import InputWrapper from '../../../components/ui/inputs/InputWrapper.vue'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import input from '../../../mixins/input'

  export default {
    name: 'text_box',

    mixins: [input],

    props: {
      limit: Number,

      required: {
        default: false
      },

      rows: {
        type: Number,
        default: 2
      },

      value: {
        type: String,
        default: ''
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    components: {
      InputWrapper,
      InputLabel
    },

    computed: {
      count() {
        return this.value.length
      }
    },

    methods: {
      dofocus() {
        this.$refs.textarea.focus()
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .text-box
    position: relative
    cursor: text
    color: $color-text

    &.is-invalid
      textarea
        border-color: $color-error

    .input-wrapper
      padding: 0
      &:after
        display: none

    .input-label
      top: 0px
      left: 10px

      .asterisk
        display: inline-block
        font-size: 15px
    //
    // &.has-value
    //   .input-label
    //     display: none

    textarea
      display: block
      resize: none
      width: 100%
      border: none
      font-family: $font-regular
      font-size: $font-size-input
      background: none
      padding: 13px 10px
      @include placeholder($color-text-light)
      border-radius: 3px
      transition: border-color $transition-duration $transition-easing
      border: 2px solid $color-primary

      &:disabled
        border: 2px solid $color-grey-dark
        
      &:focus
        outline: none

      color: $color-text

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/TextBox.vue